module.exports = __webpack_public_path__ + "static/media/8th_Count.ce5f7699.png";